module.exports = __webpack_public_path__ + "resources/img/img_tibero3.329cddc99ac014de6bb6496b272ccd08.png";